import * as form from '../form';

export const foreignActivitiesFuture = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {

        Name: form.name(xitem.Name),
        PrimaryPersonType: form.radio(xitem.PrimaryPersonType),
        InterestType: form.radio(xitem.InterestType),
        Country: form.country(xitem.Country),
        ExpectedDate: form.datecontrol(xitem.ExpectedDate),
        Reason: form.textarea(xitem.Reason),
        OtherExplanation: form.textarea(xitem.OtherExplanation),

      },
    };
  });
  return {
    HasFutureActivity: form.branch(data.HasFutureActivity),
    List: form.collection(items, (data.List || {}).branch),
  };
};
